import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4ab0a13e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "manifold m-add-to-cart-popup-container"
}
const _hoisted_2 = { class: "m-add-to-cart-popup-header" }
const _hoisted_3 = { class: "m-add-to-cart-popup-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_m_eligible_rewards = _resolveComponent("m-eligible-rewards")!

  return (_ctx.show)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(["m-add-to-cart-popup", { show: _ctx.show }])
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h1", null, _toDisplayString(_ctx.state.activeRedemption ? `${_ctx.redemptionSuccessLabel}` : ''), 1),
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
            }, "×")
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_m_eligible_rewards, { "go-back": _ctx.close }, null, 8, ["go-back"])
          ])
        ], 2)
      ]))
    : _createCommentVNode("", true)
}